import { inject, observer } from 'mobx-react';
import { useEffect, useState } from 'react';

const InfoDismissibleCard = inject('store')(
  observer(({ store, message, storageKey }) => {
    const userId = store?.profile?._id;
    const localStorageKey = `${storageKey}_${userId}`;
    const [visible, setVisible] = useState(true);
    const [dontShow, setDontShow] = useState(false);

    useEffect(() => {
      const hide = localStorage.getItem(localStorageKey) === 'true';
      if (hide) setVisible(false);
    }, [localStorageKey]);

    const handleClose = () => setVisible(false);

    const handleCheckbox = (e) => {
      const checked = e.target.checked;
      setDontShow(checked);
      if (checked) {
        localStorage.setItem(localStorageKey, 'true');
        setVisible(false);
      }
    };

    if (!visible) return null;

    return (
      <div className="absolute bottom-0 left-0 right-0 max-w-[270px] mx-auto bg-[#E6E6F7] rounded-[20px] px-6 pt-7 pb-6 shadow-md">
        <button
          aria-label="Close"
          className="absolute top-2 right-2 text-[#A0A0B2] text-2xl leading-none focus:outline-none"
          onClick={handleClose}
          tabIndex={0}
        >
          ×
        </button>
        <div className="text-[#232336] text-sm font-normal text-center">
          {message}
        </div>
        <label className="flex items-center gap-2 mt-6 text-[#7A7A9D] text-sm font-normal cursor-pointer select-none">
          <input
            type="checkbox"
            checked={dontShow}
            onChange={handleCheckbox}
            className="w-5 h-5 accent-[#A0A0B2] rounded"
          />
          Don't show this again
        </label>
      </div>
    );
  })
);

export default InfoDismissibleCard;
